import { render, staticRenderFns } from "./SLA.vue?vue&type=template&id=d890cbfa&scoped=true&"
import script from "./SLA.vue?vue&type=script&lang=js&"
export * from "./SLA.vue?vue&type=script&lang=js&"
import style0 from "./SLA.vue?vue&type=style&index=0&id=d890cbfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d890cbfa",
  null
  
)

export default component.exports